import { Suspense, useContext, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { routes } from "./config";
import { UserNav } from "shared/components/UserNav/UserNav";
import { CoolsetPageLoader } from "shared/components/Loader/CoolsetLoader";
import { Authenticated, NotAuthenticated } from "shared/components/Authenticated/Authenticated";
import { UserContext } from "contexts/UserContext/UserContext";
import { Login } from "modules/User/components/Login";
import MainSurveyEditor from "modules/MainSurveyEditor/components/MainSurveyEditor";
import Surveys from "modules/Surveys/components/Surveys";
import { SupportingInfos } from "modules/SupportingInfo/components/SupportingInfos";
import { Tags } from "modules/Tags/components/Tags";
import { GenericSnackbar } from "modules/MainSurveyEditor/components/Snackbars/GenericSnackbar/GenericSnackbar";
import { SurveyPreview } from "modules/Preview/components/SurveyPreview";

function App() {
  const { isLoggedIn, isLoadingUser } = useContext(UserContext);

  if (isLoadingUser) {
    return <CoolsetPageLoader />;
  }

  return (
    <div className="layout-app">
      {isLoggedIn && <UserNav />}
      <GenericSnackbar />
      <Suspense fallback={<CoolsetPageLoader />}>
        <NotAuthenticated>
          <Routes>
            <Route path={routes.login} element={<Login />} />
            <Route path={"*"} element={<Redirect route={routes.login} />} />
          </Routes>
        </NotAuthenticated>

        <Authenticated>
          <Routes>
            <Route path={routes.surveys} element={<Surveys />} />
            <Route path={routes.survey()} element={<MainSurveyEditor />} />
            <Route path={routes.surveyPreview()} element={<SurveyPreview />} />
            <Route path={routes.supportingInfos} element={<SupportingInfos />} />
            <Route path={routes.tags} element={<Tags />} />
            <Route path={"*"} element={<Redirect route={routes.surveys} />} />
          </Routes>
        </Authenticated>
      </Suspense>
    </div>
  );
}

const Redirect = ({ route }: { route: string }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(route);
  }, [navigate, route]);

  return null;
};

export default App;
